/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "@themesberg/react-bootstrap";
import CustomTable from "../../../components/CustomTable";
import { apiURL, fetchApi } from "../../../redux/api";

const BATCH_SIZE = 10;

function SupportingDocumentsPv({ pvInfo }) {
  const [attachmentList, setPvAttachmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (pvInfo && pvInfo.length) {
      setLoading(true);
      setLoadedCount(0);
      fetchApi(`fetch-pv-images?pv_code=${pvInfo[0].pv_code}`).then((resp) => {
        if (resp.results && resp.results.length) {
          setAttachmentListBatched(resp.results);
        } else {
          setPvAttachmentList([]);
          setLoading(false);
        }
      });
    }
  }, [pvInfo]);

  const setAttachmentListBatched = (all) => {
    if (all.length <= BATCH_SIZE) {
      setPvAttachmentList(all);
      setLoadedCount(all.length);
      setLoading(false);
    } else {
      const initial = all.slice(0, BATCH_SIZE);
      setPvAttachmentList(initial);
      setLoadedCount(BATCH_SIZE);
      const remaining = all.slice(BATCH_SIZE);
      if (remaining.length > 0) {
        intervalRef.current = setInterval(() => {
          setPvAttachmentList((prev) => {
            const next = remaining.splice(0, BATCH_SIZE);
            const updated = [...prev, ...next];
            setLoadedCount(updated.length);
            if (remaining.length === 0) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
              setLoading(false);
            }
            return updated;
          });
        }, 100);
      } else {
        setLoading(false);
      }
    }
  };

  const uploadItems = attachmentList.filter(
    (item) => !item.upload_type || item.upload_type === "upload"
  );
  const cvItems = attachmentList.filter(
    (item) => item.upload_type === "cv"
  );

  const fileField = [
    {
      title: "File Name",
      custom: true,
      component: (item) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.open(`${apiURL}/uploads/${item.image_url}`, "_blank");
          }}
        >
          {item.image_url}
        </a>
      ),
    },
  ];

  return (
    <div className="my-4">
      {loading && (
        <div className="text-center py-3">
          <Spinner animation="border" variant="primary" size="sm" className="me-2" />
          Loading documents{loadedCount > 0 ? ` (${loadedCount} loaded)` : "..."}
        </div>
      )}

      {!loading && uploadItems.length === 0 && cvItems.length === 0 && (
        <p className="text-muted small">No supporting documents found.</p>
      )}

      {uploadItems.length > 0 && (
        <>
          <h5>Supporting Documents</h5>
          <CustomTable fields={fileField} data={uploadItems} />
        </>
      )}

      {cvItems.length > 0 && (
        <div className="mt-4">
          <h5>Certificate of Valuation (CV)</h5>
          <CustomTable fields={fileField} data={cvItems} />
        </div>
      )}
    </div>
  );
}

export default SupportingDocumentsPv;
